import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'react-flexbox-grid'
import get from 'lodash/get'

import { ContentBlock, ExpandableBlocks } from 'components/ContentBlock'
import { DataTable } from 'components/DataTable'
import { Modal } from 'components/Modal'
import { Form, Text } from 'components/forms'
import Button from 'components/Button'
import KitchenLocation from './KitchenLocation'
// import { generateOptimisticPayload } from 'components/SectionHandler/helpers/data'

const columns = t => [
	{
		accessor: 'timeSlotCode',
		Header: t('common.fields.code'),
		width: 100
	}, {
		accessor: 'name',
		Header: t('common.fields.name')
	}
]

const Kitchen = ({ formData, onUpdate, sectionData, match }) => {
	const [mutateData, setMutateData] = useState()
	const [t] = useTranslation()
	const allSlots = get(formData, 'cashRegisterGlobal.kitchenTimeSlots', [])
	const tableData = allSlots.filter(({ name }) => name)
	const handleSubmit = ({ timeSlotCode, name }) => {
		const trimmedName = name.trim()
		// let outVal = allSlots.map(item => item.name)
		let outVal = {
			value: allSlots.map(item => item.name)
		}
		// Handle create
		if(!timeSlotCode) {
			outVal.value.push(trimmedName)
		} else {
			// Handle update name
			outVal.updatedItem = { timeSlotCode, name }
			allSlots.find(((item, i) => {
				if(item.timeSlotCode === timeSlotCode) {
					outVal.value[i] = name
					return true
				}
				return false
			}))
		}
		setMutateData(null)
		const mutateVal = {
			cashRegisterGlobal: {
				kitchenTimeSlots: outVal
			}
		}
		/*const subsectionLink = get(match, ['params', 'subsection'])
		const subsection = Array.isArray(sectionData.subsections) ? sectionData.subsections.find(({ link }) => link === subsectionLink) : {}
		const optimisticVals = [...allSlots, { name }]
		console.log(optimisticVals, subsection.fields, generateOptimisticPayload(subsection.fields, mutateVal, 'AppConfig'))
		onUpdate(mutateVal, { optimisticResponse: generateOptimisticPayload(subsection.fields, mutateVal, 'AppConfig') })*/


		onUpdate(mutateVal)
	}
	const handleSelect = (state, { original }) => {
		setMutateData(original)
	}
	const nameValidate = value => {
		const val = value.trim()
		if(!val) {
			return t('validators.required')
		}
		const isExisting = tableData.find(({ name }) => name === val)
		return isExisting ? t('validators.duplicate') : null
	}

	return(
		<ContentBlock label={t('options_section.sub_sections.kitchen_locations')}>
			<ExpandableBlocks nested>
				<ContentBlock label={t('options_section.sub_sections.kitchen_locations')}>
					<KitchenLocation />
				</ContentBlock>
				<ContentBlock label={t('options_section.strings.time_ranges_for_unattended_systems')}>
					<Row>
						<Col xs={6}>
							<DataTable
								data={tableData}
								columns={columns(t)}
								onAddRecord={() => setMutateData({})}
								onRowClick={handleSelect}
								sortable={false}
								resizable={false}
							/>
						</Col>
					</Row>
					{mutateData &&
				<Modal unmount={() => setMutateData(null)} label={t('options_section.strings.edit_time_slots')} width={500}>
					<Form
						initialValues={mutateData}
						onSubmit={handleSubmit}
					>
						<div><Text field='timeSlotCode' hidden /></div>
						<Text
							field='name'
							label={t('common.fields.name')}
							validate={nameValidate}
							validateOnChange
						/>
						<Button text={t('common.buttons.apply')} type='submit' />
					</Form>
				</Modal>
					}
				</ContentBlock>
			</ExpandableBlocks>
		</ContentBlock>
	)
}

export default Kitchen
